
import React from 'react';
import { PropertyField } from '../../molecules/PropertyField';
import { WorkflowNodeData } from '../../../types';

interface HttpTabProps {
    data: WorkflowNodeData;
    onChange: (key: string, value: any) => void;
}

export const HttpTab: React.FC<HttpTabProps> = ({ data, onChange }) => {
    return (
        <div className="p-6 space-y-4">
             <div className="grid grid-cols-2 gap-4">
                 <PropertyField
                     config={{ name: 'service', label: 'Service URL', type: 'text', placeholder: 'http://svc-identity:80', validation: { required: true }}}
                     value={data.service}
                     onChange={onChange}
                 />
                 <PropertyField
                     config={{ name: 'endpoint', label: 'Endpoint Path', type: 'text', placeholder: '/api/Person' }}
                     value={data.endpoint}
                     onChange={onChange}
                 />
             </div>
             <div className="grid grid-cols-2 gap-4">
                 <PropertyField 
                     config={{ name: 'method', label: 'Method', type: 'select', options: [{ value: 'GET', label: 'GET' }, { value: 'POST', label: 'POST' }, { value: 'PUT', label: 'PUT' }, { value: 'DELETE', label: 'DELETE' }], defaultValue: 'GET' }}
                     value={data.method}
                     onChange={onChange}
                 />
                 <PropertyField 
                     config={{ name: 'authentication', label: 'Authentication', type: 'select', options: [{ value: 'none', label: 'None' }, { value: 'bearer', label: 'Bearer Token' }, { value: 'basic', label: 'Basic Auth' }, { value: 'api-key', label: 'API Key' }], defaultValue: 'none' }}
                     value={data.authentication}
                     onChange={onChange}
                 />
             </div>
             
             {data.authentication === 'bearer' && (
                 <PropertyField 
                    config={{ name: 'bearerToken', label: 'Bearer Token', type: 'text' }}
                    value={data.bearerToken}
                    onChange={onChange}
                 />
             )}
             
             {data.authentication === 'api-key' && (
                 <PropertyField 
                    config={{ name: 'apiKey', label: 'API Key', type: 'text' }}
                    value={data.apiKey}
                    onChange={onChange}
                 />
             )}

             <PropertyField 
                 config={{ name: 'headers', label: 'Headers (JSON)', type: 'object', rows: 4 }}
                 value={data.headers}
                 onChange={onChange}
             />
             
             {(data.method === 'POST' || data.method === 'PUT') && (
                 <PropertyField 
                     config={{ name: 'requestBody', label: 'Request Body', type: 'textarea', rows: 6, placeholder: '{\n  "key": "value"\n}' }}
                     value={data.requestBody}
                     onChange={onChange}
                 />
             )}
        </div>
    );
};
